import React from 'react';

export const ArrowRightIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.84688 5.37801L1.44612 9.84536C1.21928 10.0515 0.879017 10.0515 0.674858 9.84536L0.153119 9.31844C-0.0510397 9.11226 -0.0510397 8.76861 0.153119 8.53952L3.6465 4.98855L0.153119 1.46048C-0.0510397 1.23139 -0.0510397 0.887743 0.153119 0.681558L0.674858 0.154639C0.879017 -0.0515464 1.21928 -0.0515464 1.44612 0.154639L5.84688 4.62199C6.05104 4.82818 6.05104 5.17182 5.84688 5.37801Z"
      fill="#AAAAAA"
    />
  </svg>
);
